import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const trimValueToMaxlength = (value, maxLength) => {
  if(!value) return "";
  return value.substring(0, (value.length > maxLength) ? maxLength : value.length);
}

const CharsRemainingContainer = styled('div')`
  text-align:right;
  font-size:12px;
`;

export default class CharsRemainingTextArea extends React.Component {
  constructor(props){
    super(props);
    let newValue = trimValueToMaxlength(this.props.value, this.props.maxLength);
    this.state = {
      charCount: newValue.length,
      value: newValue
    };
  }

  componentDidUpdate (prevProps) {
    if (this.props.value && this.state.value !== this.props.value) {
      this.handleChange(this.props.value);
    }
  }

  handleChange = (value) => {
    let newValue = trimValueToMaxlength(value, this.props.maxLength);
    this.setState({ value: newValue, charCount: newValue.length });
  }

  onKeyUp = (event) => {
    this.handleChange(event.target.value);
    if(this.props.onKeyUp) this.props.onKeyUp(event);
  }

  onChange = (event) => {
    this.handleChange(event.target.value);
    if(this.props.onChange) this.props.onChange(event);
  }

  render() {
    return (
      <React.Fragment>
        <textarea 
          {...this.props}
          value={this.state.value}
          onKeyUp={(event) => this.onKeyUp(event)}
          onChange={(event) => this.onChange(event)}
          rows={6}
          
        />
        <CharsRemainingContainer>
          {this.state.charCount} of {this.props.maxLength} characters remaining
        </CharsRemainingContainer>
      </React.Fragment>
    );
  }
}

CharsRemainingTextArea.propTypes = {
  maxLength: PropTypes.number.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/forms/CharsRemainingTextArea.js